import React from 'react';
import SideNav from './SideNav';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import { Outlet } from 'react-router-dom';
import { useEffect } from 'react';
const AuthorLayout = () => {
  
  useEffect(() => {
    
    document.title = "Author - Technical Paper Platform";
  }, []);


    return (
        <div className="wrapper">
          <Header/>
        <SideNav />
  
        <div className="content-wrapper" style={{ minHeight: '100vh' }}>
          <section className="content pt-3 px-3">
            <div className="container-fluid">
            <Outlet />
            </div>
          </section>
        </div>
  
        <Footer />
      </div>
    );
};

export default AuthorLayout;